
import ApplicationTitle from '../../components/ApplicationTitle';
import TextInput from '../../components/input_fields/TextInput';
import SelectInput from '../../components/input_fields/SelectInput';
import Terms from '../../components/Terms';
import TwoInputs from '../../components/input_fields/TwoInputs'
import StackedTitle from '../../components/form_titles/StackedTitle';
import DoubleButton from '../../components/buttons/DoubleButton';
import ProgressBar from '../../components/progress/ProgressBar';

import validator from "validator";
import React, { useState } from "react";


export default function Step1({ nextHalfStep, prevStep, handleFormData, values, validation, color }) {

    const [phoneError, setPhoneError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [fnameError, setfnameError] = useState(false)
    const [lnameError, setlnameError] = useState(false)

    const submitFormData = (e) => {
        e.preventDefault();
        //fname Errors
        if (validation) {
            if (validator.isEmpty(values.primaryContactfName)) {
                setfnameError(true)
                return
            } setfnameError(false)
    
            //lname Errors
            if (validator.isEmpty(values.primaryContactlName)) {
                setlnameError(true)
                return
            } setlnameError(false)
    
            // Phone Errors
            if (!validator.isMobilePhone(values.primaryContactPhone)) {
                setPhoneError(true)
                return
            } setPhoneError(false)
    
            // Email Errors
            if (!validator.isEmail(values.primaryContactEmail)) {
                setEmailError(true)
                return
            } setEmailError(false)
        }

        
        nextHalfStep();

    };

    return (
        <div className="bg-white-900 dark:bg-white-900 w-full">
            <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
                {/* <ApplicationTitle
                    mainTitle="Bipsypay Merchant Application"
                    subTitle="Complete the form below to begin your Bipsypay merchant application"
                /> */}
                <ProgressBar
                    progress = "18%"
                    color =  {color}
                />
                <div className="bg-white rounded-lg shadow dark:border">
                    <div className="p-6 space-y-1 sm:p-8">
                        <StackedTitle
                            color = {color}
                            mainTitle="We need someone to"
                            colorTitle="contact."
                            subText="Please fill in the primary contact's information below."
                        />
                        <form className="space-y-4" onSubmit={submitFormData}>
                            <TwoInputs
                                color = {color}
                                placeholder1="Contact First Name" id1="primary_fname" type1="Text" name1="primaryContactfName" value1 = {values.primaryContactfName}
                                error1 = {fnameError} message1 = "Please enter the contact's first name"
                                handleInputChange1={handleFormData}
                                placeholder2="Contact Last Name" id2="primary_lname" type2="Text" name2="primaryContactlName" value2 = {values.primaryContactlName}
                                error2 = {lnameError} message2 = "Please enter the contact's last name"
                                handleInputChange2={handleFormData}
                            />

                            <TextInput
                                color = {color}
                                placeholder="Contact Phone Number" name="primaryContactPhone" value = {values.primaryContactPhone}
                                error = {phoneError} message = "Please enter a valid phone number" 
                                handleInputChange={handleFormData} 
                            />

                            <TextInput 
                                color = {color}
                                placeholder="Contact Email" name="primaryContactEmail" value = {values.primaryContactEmail}
                                error = {emailError} message = "Please enter a valid email address"
                                handleInputChange={handleFormData} 
                            />
                            <DoubleButton prevStep = {prevStep} color = {color}></DoubleButton>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}